/**
 * Maxi — alinha Frete no Produto (PDP) com o checkout.
 * Usa /cart/shipping_rates.json (mesma fonte do carrinho/checkout)
 * para sobrescrever preço + dias úteis + data prevista, sem trocar o bloco.
 * Velocidade: UF pelo CEP sem site externo, cálculo começa junto com o app,
 * resultado guardado na sessão e reaproveitado.
 * Sem troca visível: enquanto os prazos reais não chegam, a lista do app fica escondida
 * com "Calculando frete e prazo de entrega…" (no máximo 8s; depois mostra a do app).
 */
(function () {
  'use strict';

  if (window.theme && window.theme.pageType && window.theme.pageType !== 'product') return;

  var moneyFmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var aligning = false;
  var lastKey = '';

  function extractIsoDate(value) {
    if (!value) return null;
    var match = String(value).match(/\d{4}-\d{2}-\d{2}/);
    return match ? match[0] : null;
  }

  function startOfDay(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function businessDaysBetween(fromDate, toDate) {
    var count = 0;
    var cursor = startOfDay(fromDate);
    var end = startOfDay(toDate);
    if (end <= cursor) return 0;
    while (cursor < end) {
      cursor.setDate(cursor.getDate() + 1);
      var day = cursor.getDay();
      if (day !== 0 && day !== 6) count += 1;
    }
    return count;
  }

  function addBusinessDays(fromDate, days) {
    var cursor = startOfDay(fromDate);
    var left = Math.max(0, days);
    while (left > 0) {
      cursor.setDate(cursor.getDate() + 1);
      var day = cursor.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return cursor;
  }

  function formatDateBR(isoOrDate) {
    if (!isoOrDate) return '';
    var d = typeof isoOrDate === 'string' ? new Date(isoOrDate + 'T12:00:00') : isoOrDate;
    if (Number.isNaN(d.getTime())) return '';
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var yy = String(d.getFullYear()).slice(-2);
    return dd + '/' + mm + '/' + yy;
  }

  function formatDiasUteis(minDays, maxDays) {
    if (minDays == null || Number.isNaN(minDays)) return 'Consulte o prazo';
    var min = Math.max(0, minDays);
    var max = Math.max(min, maxDays == null ? min : maxDays);
    if (max <= 0) return 'Hoje';
    if (min === max) return min === 1 ? '1 dia útil' : min + ' dias úteis';
    return min + ' a ' + max + ' dias úteis';
  }

  function formatPrazoParts(item) {
    var daysMin = null;
    var daysMax = null;
    var dateMin = null;
    var dateMax = null;

    var deliveryDays = item.delivery_days;
    if (Array.isArray(deliveryDays) && deliveryDays.length) {
      var nums = deliveryDays.map(Number).filter(function (n) { return !Number.isNaN(n); });
      if (nums.length) {
        daysMin = Math.min.apply(null, nums);
        daysMax = Math.max.apply(null, nums);
      }
    } else if (deliveryDays != null && deliveryDays !== '') {
      var n = parseInt(deliveryDays, 10);
      if (!Number.isNaN(n)) {
        daysMin = n;
        daysMax = n;
      }
    }

    dateMin = extractIsoDate(item.delivery_date);
    dateMax = dateMin;
    if (Array.isArray(item.delivery_range) && item.delivery_range.length) {
      dateMin = extractIsoDate(item.delivery_range[0]) || dateMin;
      dateMax = extractIsoDate(item.delivery_range[item.delivery_range.length - 1]) || dateMax;
    } else if (typeof item.delivery_range === 'string' && item.delivery_range) {
      var dates = item.delivery_range.match(/\d{4}-\d{2}-\d{2}/g);
      if (dates && dates.length) {
        dateMin = dates[0];
        dateMax = dates[dates.length - 1];
      }
    }
    if (!dateMin) dateMin = extractIsoDate(item.min_delivery_date);
    if (!dateMax) dateMax = extractIsoDate(item.max_delivery_date) || dateMin;

    var today = startOfDay(new Date());
    if (daysMin == null && dateMin) {
      daysMin = businessDaysBetween(today, new Date(dateMin + 'T12:00:00'));
      daysMax = dateMax && dateMax !== dateMin
        ? businessDaysBetween(today, new Date(dateMax + 'T12:00:00'))
        : daysMin;
    }
    if (!dateMin && daysMin != null) {
      dateMin = addBusinessDays(today, daysMin);
      dateMax = daysMax != null && daysMax !== daysMin ? addBusinessDays(today, daysMax) : dateMin;
    }

    var prazoLabel = formatDiasUteis(daysMin, daysMax);
    var dateLabel = '';
    if (dateMin instanceof Date) {
      var minLabel = formatDateBR(dateMin);
      var maxLabel = formatDateBR(dateMax instanceof Date ? dateMax : dateMin);
      dateLabel = minLabel && maxLabel && minLabel !== maxLabel ? minLabel + ' a ' + maxLabel : minLabel;
    } else if (dateMin) {
      minLabel = formatDateBR(dateMin);
      maxLabel = formatDateBR(dateMax || dateMin);
      dateLabel = minLabel && maxLabel && minLabel !== maxLabel ? minLabel + ' a ' + maxLabel : minLabel;
    }

    return {
      prazoLabel: prazoLabel,
      dateLabel: dateLabel,
      text: dateLabel ? prazoLabel + ' · Previsão ' + dateLabel : prazoLabel
    };
  }

  function formatPrice(rate) {
    var price = parseFloat(rate.price);
    if (Number.isNaN(price)) return '';
    if (price === 0) return 'Grátis';
    return moneyFmt.format(price);
  }

  function normalizeName(name) {
    return String(name || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseMoney(text) {
    var m = String(text || '').match(/R\$\s*([\d.]*\d,\d{2})/);
    if (!m) return null;
    return parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCartCookie(value) {
    document.cookie = 'cart=' + value + '; path=/';
  }

  function findCepInput(root) {
    var scope = root || document;
    var inputs = scope.querySelectorAll('input[type="text"], input[type="tel"], input[type="search"], input:not([type])');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var ph = (el.getAttribute('placeholder') || '').toLowerCase();
      var name = (el.getAttribute('name') || '').toLowerCase();
      var id = (el.id || '').toLowerCase();
      if (ph.indexOf('cep') !== -1 || name.indexOf('cep') !== -1 || name.indexOf('zip') !== -1 || id.indexOf('cep') !== -1) {
        return el;
      }
    }
    return null;
  }

  var UF_TO_PROVINCE = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará',
    DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão', MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná',
    PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina',
    SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins'
  };

  /* Estado (UF) pelo próprio número do CEP, sem consultar site externo (era o ViaCEP). */
  var CEP_RANGES = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];

  function ufFromCep(clean) {
    var prefix = parseInt(String(clean).slice(0, 5), 10);
    for (var i = 0; i < CEP_RANGES.length; i++) {
      if (prefix >= CEP_RANGES[i][0] && prefix <= CEP_RANGES[i][1]) return CEP_RANGES[i][2];
    }
    return '';
  }

  function getProvinceFromCep(cep) {
    var clean = String(cep || '').replace(/\D/g, '');
    if (clean.length !== 8) return Promise.resolve('');
    var uf = ufFromCep(clean);
    return Promise.resolve(uf ? (UF_TO_PROVINCE[uf] || uf) : '');
  }

  function getVariantPayload() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var id = idInput ? idInput.value : '';
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!id) return null;
    return { id: id, quantity: qty > 0 ? qty : 1 };
  }

  /* Guarda o resultado (memória + sessão, 20 min) e reaproveita um cálculo que já está em andamento,
     para o valor aparecer na hora ao repetir o mesmo CEP ou quando o app redesenhar o bloco. */
  var RATES_TTL = 20 * 60 * 1000;
  var ratesMemory = {};
  var ratesInflight = {};

  function ratesKey(zip) {
    var payload = getVariantPayload();
    if (!payload) return '';
    return String(zip || '').replace(/\D/g, '') + '|' + payload.id + 'x' + payload.quantity;
  }

  function readCachedRates(key) {
    if (!key) return null;
    var hit = ratesMemory[key];
    if (!hit) {
      try {
        var raw = window.sessionStorage.getItem('maxiFrete:' + key);
        if (raw) hit = JSON.parse(raw);
      } catch (e) {}
    }
    if (hit && hit.t && Date.now() - hit.t < RATES_TTL && hit.r && hit.r.length) {
      ratesMemory[key] = hit;
      return hit.r;
    }
    return null;
  }

  function storeCachedRates(key, rates) {
    if (!key || !rates || !rates.length) return;
    var entry = { t: Date.now(), r: rates };
    ratesMemory[key] = entry;
    try { window.sessionStorage.setItem('maxiFrete:' + key, JSON.stringify(entry)); } catch (e) {}
  }

  function fetchCheckoutRates(zip, province) {
    var key = ratesKey(zip);
    var cached = readCachedRates(key);
    if (cached) return Promise.resolve(cached);
    if (key && ratesInflight[key]) return ratesInflight[key];

    var request = fetchCheckoutRatesFromShopify(zip, province).then(function (rates) {
      storeCachedRates(key, rates);
      return rates;
    });
    if (key) {
      ratesInflight[key] = request;
      request.then(clearInflight, clearInflight);
    }
    function clearInflight() { delete ratesInflight[key]; }
    return request;
  }

  /* Começa o cálculo junto com o app (no clique em Consultar ou Enter no CEP),
     em vez de esperar o app terminar. */
  function prefetchRates(root) {
    var cepInput = findCepInput(root) || findCepInput(document);
    if (!cepInput) return;
    var zip = String(cepInput.value || '').replace(/\D/g, '');
    if (zip.length !== 8) return;
    getProvinceFromCep(zip).then(function (uf) { return fetchCheckoutRates(zip, uf); });
  }

  function fetchCheckoutRatesFromShopify(zip, province) {
    var cleanZip = String(zip || '').replace(/\D/g, '');
    if (cleanZip.length < 8) return Promise.resolve([]);

    var cartUrl = (window.routes && window.routes.cartUrl) ? window.routes.cartUrl : '/cart';
    var addUrl = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add';
    var payload = getVariantPayload();

    var realCart = getCookie('cart');
    var fakeCart = 'fake-cart-cookie___' + Date.now() + Math.floor(Math.random() * 1000);

    function restoreCart() {
      if (realCart) setCartCookie(realCart);
    }

    function queryRates() {
      var url =
        cartUrl +
        '/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(cleanZip) +
        '&shipping_address[country]=Brazil';
      if (province) url += '&shipping_address[province]=' + encodeURIComponent(province);
      return fetch(url, { credentials: 'same-origin', method: 'GET' })
        .then(function (res) { return res.json().then(function (data) { return res.ok ? (data.shipping_rates || []) : []; }); });
    }

    // Sem variante: usa o carrinho atual (mesmo do checkout se o item já estiver lá)
    if (!payload) {
      return queryRates();
    }

    // Carrinho temporário só com o produto da PDP — mesma base do checkout desse item
    setCartCookie(fakeCart);
    return fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return queryRates();
      })
      .then(function (rates) {
        restoreCart();
        return rates;
      })
      .catch(function () {
        restoreCart();
        return queryRates();
      });
  }

  function buildRateMap(rates) {
    var map = {};
    (rates || []).forEach(function (rate) {
      var parts = formatPrazoParts(rate);
      var entry = {
        priceText: formatPrice(rate),
        priceNumber: parseFloat(rate.price) || 0,
        prazoLabel: parts.prazoLabel,
        dateLabel: parts.dateLabel,
        prazoText: parts.text,
        name: rate.name || rate.presentment_name || ''
      };
      var keys = [rate.name, rate.presentment_name, entry.name];
      keys.forEach(function (k) {
        var nk = normalizeName(k);
        if (nk) map[nk] = entry;
      });
    });
    return map;
  }

  function matchRateByText(text, byName) {
    var normalized = normalizeName(text);
    if (!normalized) return null;
    if (byName[normalized]) return byName[normalized];
    var keys = Object.keys(byName);
    var hits = [];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!key || key.length < 3) continue;
      if (normalized === key || normalized.indexOf(key) !== -1) hits.push(key);
    }
    if (!hits.length) return null;
    // Se o texto tem várias transportadoras, não chutar pelo nome mais longo
    if (hits.length > 1) {
      hits.sort(function (a, b) { return b.length - a.length; });
      // só aceita se o texto for essencialmente só aquele nome
      if (normalized === hits[0] || normalized.indexOf(hits[0]) === 0 && normalized.length < hits[0].length + 8) {
        return byName[hits[0]];
      }
      return null;
    }
    return byName[hits[0]];
  }

  function findClosestCarrier(node, byName) {
    var el = node;
    for (var depth = 0; depth < 10 && el; depth++) {
      var normalized = normalizeName(el.textContent || '');
      var keys = Object.keys(byName);
      var hits = [];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!key || key.length < 3) continue;
        if (normalized.indexOf(key) !== -1) hits.push(key);
      }
      // único match no ancestral → fechou
      if (hits.length === 1) return byName[hits[0]];

      // vários matches: pega o nome que aparece mais perto ANTES do nó de preço
      if (hits.length > 1 && el.contains && el.contains(node)) {
        var before = normalized;
        try {
          var range = document.createRange();
          range.selectNodeContents(el);
          range.setEnd(node, 0);
          before = normalizeName(range.toString());
        } catch (err) { /* ignore */ }
        var best = null;
        var bestPos = -1;
        for (var j = 0; j < hits.length; j++) {
          var pos = before.lastIndexOf(hits[j]);
          if (pos > bestPos) {
            bestPos = pos;
            best = byName[hits[j]];
          }
        }
        if (best && bestPos >= 0) return best;
      }

      el = el.parentElement;
    }
    return null;
  }

  function rewriteResults(container, rates) {
    if (!container || !rates || !rates.length) return;
    var byName = buildRateMap(rates);

    // 1) Atualiza nós que são exatamente o nome da transportadora
    var nodes = container.querySelectorAll('p, span, div, li, td, strong, b');
    nodes.forEach(function (node) {
      if (node.children && node.children.length > 2) return;
      var text = (node.textContent || '').trim();
      if (!text || text.length > 80) return;
      var rate = matchRateByText(text, byName);
      if (!rate) return;

      var sibling = node.nextElementSibling;
      while (sibling) {
        var sText = (sibling.textContent || '').trim();
        if (/R\$\s*[\d.,]+/i.test(sText) || /gr[aá]tis/i.test(sText)) {
          if (rate.priceText && sibling.childNodes.length <= 2) {
            sibling.textContent = rate.priceText;
            sibling.setAttribute('data-maxi-price-fixed', '1');
          }
        } else if (/dia|útil|util|previs|\d{1,2}\/\d{1,2}/i.test(sText)) {
          if (sibling.childNodes.length <= 3) {
            sibling.textContent = rate.prazoText;
            sibling.setAttribute('data-maxi-prazo-fixed', '1');
          }
        }
        sibling = sibling.nextElementSibling;
      }
    });

    // 2) Varredura de preços e prazos soltos, ligados à transportadora do card
    nodes.forEach(function (node) {
      if (node.children && node.children.length > 1) return;
      var text = (node.textContent || '').trim();
      if (!text) return;

      var rate = findClosestCarrier(node, byName);
      if (!rate) return;

      var money = parseMoney(text);
      if (money != null && rate.priceText) {
        if (node.getAttribute('data-maxi-price-fixed') === '1' && Math.abs(money - rate.priceNumber) < 0.01) return;
        // só corrige se for diferente (tolerância 1 centavo)
        if (Math.abs(money - rate.priceNumber) >= 0.01) {
          node.textContent = text.replace(/R\$\s*[\d.]*\d,\d{2}/, rate.priceText).replace(/Gr[aá]tis/i, rate.priceText);
          if (node.textContent === text) node.textContent = rate.priceText;
          node.setAttribute('data-maxi-price-fixed', '1');
        }
        return;
      }

      if (node.getAttribute('data-maxi-prazo-fixed') === '1') return;
      if (/(\d+\s*dias?)|(\d{1,2}\/\d{1,2}\/\d{2,4})|(útil|util|previs)/i.test(text)) {
        if (!/R\$/i.test(text)) {
          node.textContent = rate.prazoText;
          node.setAttribute('data-maxi-prazo-fixed', '1');
        }
      }
    });

    // 3) Folha com nome + preço na mesma linha (sem destruir irmãos)
    nodes.forEach(function (node) {
      if (node.children && node.children.length > 0) return;
      var text = (node.textContent || '').trim();
      if (!text || !/R\$/.test(text)) return;
      var normalized = normalizeName(text);
      var keys = Object.keys(byName);
      var hits = [];
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].length >= 3 && normalized.indexOf(keys[i]) !== -1) hits.push(keys[i]);
      }
      if (hits.length !== 1) return;
      var rate = byName[hits[0]];
      if (!rate || !rate.priceText) return;
      var money = parseMoney(text);
      if (money != null && Math.abs(money - rate.priceNumber) >= 0.01) {
        node.textContent = text.replace(/R\$\s*[\d.]*\d,\d{2}/, rate.priceText);
        node.setAttribute('data-maxi-price-fixed', '1');
      }
    });
  }

  function looksLikeResults(root) {
    var text = root.textContent || '';
    return /R\$\s*\d/.test(text) && /(dia|útil|util|\d{1,2}\/\d{1,2})/i.test(text);
  }

  function alignRoot(root) {
    if (aligning) return;
    var cepInput = findCepInput(root) || findCepInput(document);
    if (!cepInput) return;
    var zip = String(cepInput.value || '').replace(/\D/g, '');
    if (zip.length < 8) return;
    if (!looksLikeResults(root)) return;

    var variant = getVariantPayload();
    var key = zip + '|' + (variant ? variant.id + 'x' + variant.quantity : 'cart');
    // evita loop infinito do MutationObserver
    if (key === lastKey && root.getAttribute('data-maxi-frete-aligned') === key) return;

    aligning = true;
    getProvinceFromCep(zip)
      .then(function (uf) {
        return fetchCheckoutRates(zip, uf);
      })
      .then(function (rates) {
        if (!rates.length) {
          setPending(root, false);
          return;
        }
        rewriteResults(root, rates);
        lastKey = key;
        root.setAttribute('data-maxi-frete-aligned', key);
        collapseExtraCarriers(root);
        setPending(root, false);
        // Frete no Produto às vezes reescreve o DOM depois — reaplica 1–2x
        window.setTimeout(function () {
          if (root.getAttribute('data-maxi-frete-aligned') === key) {
            rewriteResults(root, rates);
            collapseExtraCarriers(root);
          }
        }, 700);
        window.setTimeout(function () {
          if (root.getAttribute('data-maxi-frete-aligned') === key) {
            rewriteResults(root, rates);
            collapseExtraCarriers(root);
          }
        }, 1600);
        collapseExtraCarriers(root);
      })
      .catch(function () {
        setPending(root, false);
      })
      .finally(function () {
        aligning = false;
      });
  }

  /* ---------- "Calculando…": esconde a lista do app até os prazos reais chegarem ---------- */
  var PENDING_MAX_MS = 8000;

  (function injectPendingStyles() {
    if (document.getElementById('maxi-frete-pending-style')) return;
    var style = document.createElement('style');
    style.id = 'maxi-frete-pending-style';
    style.textContent =
      '.maxi-frete-pending [data-maxi-carrier-list],' +
      '.maxi-frete-pending .maxi-mais-transportadoras{visibility:hidden!important;}' +
      '.maxi-frete-loading{margin:10px 0;font-size:13px;color:#555;}' +
      '.maxi-frete-loading::before{content:"";display:inline-block;width:12px;height:12px;margin-right:8px;' +
      'vertical-align:-1px;border:2px solid #c9ced3;border-top-color:#226ce0;border-radius:50%;' +
      'animation:maxiFreteSpin .8s linear infinite;}' +
      '@keyframes maxiFreteSpin{to{transform:rotate(360deg);}}';
    (document.head || document.documentElement).appendChild(style);
  })();

  function markPendingList(root) {
    if (!root.classList.contains('maxi-frete-pending')) return;
    var list = findCarrierList(root);
    if (!list) return;
    if (!list.hasAttribute('data-maxi-carrier-list')) list.setAttribute('data-maxi-carrier-list', '');
    var loading = root.querySelector('.maxi-frete-loading');
    if (!loading && list.parentNode) {
      loading = document.createElement('p');
      loading.className = 'maxi-frete-loading';
      loading.setAttribute('role', 'status');
      loading.textContent = 'Calculando frete e prazo de entrega…';
      list.parentNode.insertBefore(loading, list);
    }
  }

  function currentRatesKey(root) {
    var cepInput = findCepInput(root) || findCepInput(document);
    if (!cepInput) return '';
    var zip = String(cepInput.value || '').replace(/\D/g, '');
    if (zip.length < 8) return '';
    var variant = getVariantPayload();
    return zip + '|' + (variant ? variant.id + 'x' + variant.quantity : 'cart');
  }

  function setPending(root, on) {
    if (!root) return;
    window.clearTimeout(root._maxiPendingTimer);
    if (on) {
      root.classList.add('maxi-frete-pending');
      root._maxiPendingTimer = window.setTimeout(function () {
        // Passou do tempo: mostra a lista do app e não esconde de novo para este CEP/produto
        root._maxiGaveUpKey = currentRatesKey(root);
        setPending(root, false);
      }, PENDING_MAX_MS);
      markPendingList(root);
    } else {
      root.classList.remove('maxi-frete-pending');
      var loading = root.querySelector('.maxi-frete-loading');
      if (loading) loading.remove();
    }
  }

  /* Resultado do app apareceu e ainda não foi corrigido para este CEP/produto: esconde até corrigir */
  function maybeStartPending(root) {
    if (root.classList.contains('maxi-frete-pending')) {
      markPendingList(root);
      return;
    }
    if (!looksLikeResults(root)) return;
    var key = currentRatesKey(root);
    if (!key) return;
    if (root.getAttribute('data-maxi-frete-aligned') === key) return;
    if (root._maxiGaveUpKey === key) return;
    setPending(root, true);
  }

  function findCarrierList(root) {
    var lists = root.querySelectorAll('ul');
    for (var i = 0; i < lists.length; i++) {
      var lis = lists[i].querySelectorAll(':scope > li');
      if (lis.length < 2) continue;
      var withPrice = 0;
      for (var j = 0; j < lis.length; j++) {
        if (/R\$\s*[\d.,]+/i.test(lis[j].textContent || '') || lis[j].querySelector('.ship-price')) {
          withPrice += 1;
        }
      }
      if (withPrice >= 2) return lists[i];
    }
    return null;
  }

  function collapseExtraCarriers(root) {
    if (!root) return;
    var list = findCarrierList(root);
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
    var rateItems = items.filter(function (li) {
      return /R\$\s*[\d.,]+/i.test(li.textContent || '') || !!li.querySelector('.ship-price');
    });
    if (rateItems.length < 2) {
      var oldBtn = root.querySelector('.maxi-mais-transportadoras');
      if (oldBtn) oldBtn.remove();
      root.classList.remove('is-maxi-carriers-open');
      return;
    }

    rateItems.forEach(function (li, index) {
      if (index === 0) {
        li.classList.remove('maxi-carrier-extra');
      } else {
        li.classList.add('maxi-carrier-extra');
      }
    });

    var host = root.querySelector('.calculoFrete') || root;
    var btn = host.querySelector(':scope > .maxi-mais-transportadoras') || root.querySelector('.maxi-mais-transportadoras');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'maxi-mais-transportadoras';
      btn.setAttribute('data-maxi-carrier-toggle', '1');
      // Insere logo após a lista de fretes
      if (list.parentNode) {
        list.parentNode.insertBefore(btn, list.nextSibling);
      } else {
        host.appendChild(btn);
      }
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = host.classList.toggle('is-maxi-carriers-open');
        root._maxiCarriersExpanded = open;
        btn.textContent = open ? 'Menos Transportadoras' : 'Mais Transportadoras';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var expanded = !!root._maxiCarriersExpanded;
    host.classList.toggle('is-maxi-carriers-open', expanded);
    btn.textContent = expanded ? 'Menos Transportadoras' : 'Mais Transportadoras';
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.hidden = false;
  }

  function watchFreteApp() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll('.shopify-app-block, [id*="frete"], [id*="Frete"], [class*="frete"], [class*="Frete"], [class*="shipping"], .calculoFrete')
    );
    if (!roots.length) return;

    roots.forEach(function (root) {
      // Preferir o bloco calculoFrete / app-block pai
      if (root.classList && root.classList.contains('calculoFrete') && root.closest('.shopify-app-block')) {
        root = root.closest('.shopify-app-block');
      }
      if (root._maxiFreteWatch) return;
      root._maxiFreteWatch = true;

      var timer = null;
      var obs = new MutationObserver(function () {
        maybeStartPending(root);
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          alignRoot(root);
          collapseExtraCarriers(root);
        }, 150);
      });
      obs.observe(root, { childList: true, subtree: true, characterData: true });

      var cepInput = findCepInput(root);
      if (cepInput) {
        cepInput.addEventListener('change', function () {
          root.removeAttribute('data-maxi-frete-aligned');
          root._maxiCarriersExpanded = false;
          lastKey = '';
        });
        cepInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            root.removeAttribute('data-maxi-frete-aligned');
            lastKey = '';
            root._maxiGaveUpKey = '';
            setPending(root, true);
            prefetchRates(root);
          }
        });
      }
      root.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('[data-maxi-carrier-toggle], .maxi-mais-transportadoras')) {
          return;
        }
        var btn = event.target.closest ? event.target.closest('button') : null;
        if (!btn || !/consultar/i.test(btn.textContent || '')) return;
        root._maxiCarriersExpanded = false;
        root.removeAttribute('data-maxi-frete-aligned');
        lastKey = '';
        root._maxiGaveUpKey = '';
        setPending(root, true);
        prefetchRates(root);
        window.setTimeout(function () {
          root.removeAttribute('data-maxi-frete-aligned');
          alignRoot(root);
          collapseExtraCarriers(root);
        }, 800);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchFreteApp);
  } else {
    watchFreteApp();
  }
  window.setTimeout(watchFreteApp, 1200);
  window.setTimeout(watchFreteApp, 3000);
})();
